import React from 'react';
import { getLocation } from 'connected-react-router';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import isEqual from 'lodash/isEqual';
import queryValuesToString from 'lib/routing/queryValuesToString';
import { getRoute, getQueryParams } from 'store/router/routerSelectors';
import { isServer } from 'lib/renderHelpers';

const UrlSanitizer = () => {
  const query = useSelector(getQueryParams);
  const route = useSelector(getRoute);
  const location = useSelector(getLocation);

  // NOTE: Don't run the sanitizer on the server as it always sanitizes dates according to the
  // servers time zone, not the client time zone
  if (isServer() || !route) return null;

  const sanitizedQuery = route.sanitizeQuery ? route.sanitizeQuery(query) : query;
  const didSanitize = !isEqual(query, sanitizedQuery);

  if (didSanitize) {
    const sanitizedLocation = { ...location, search: queryString.stringify(queryValuesToString(sanitizedQuery)) };
    return <Redirect to={sanitizedLocation} />;
  }

  return null;
};

export default UrlSanitizer;
